
// init.js
// Using @hotwired/turbo for SPA-like navigation (replaces jquery-pjax)

import * as Turbo from '@hotwired/turbo';

export function initApp() {
    const Facturavia = window.Facturavia;
    let loadingTimeout;

    // ── Turbo Frame Progress Bar ──
    const progressBar = document.createElement('div');
    progressBar.className = 'turbo-frame-progress-bar';
    document.documentElement.appendChild(progressBar);
    let progressBarTimeout;

    function showProgressBar() {
        clearTimeout(progressBarTimeout);
        progressBarTimeout = setTimeout(function () {
            progressBar.classList.remove('complete');
            progressBar.style.width = '';
            void progressBar.offsetWidth;
            progressBar.classList.add('active', 'loading');
        }, 1000);
    }

    function hideProgressBar() {
        clearTimeout(progressBarTimeout);
        progressBar.classList.remove('loading');
        progressBar.classList.add('complete');
        // Clean up after transition
        setTimeout(function () {
            progressBar.classList.remove('active', 'complete');
            progressBar.style.width = '';
        }, 350);
    }

    // Suppress benign AbortError rejections from Turbo.
    // When the user clicks a link while a previous Turbo Frame fetch is still
    // in-flight, the old request is aborted and Turbo lets the rejection bubble
    // up as an unhandled promise rejection. This is harmless — it simply means
    // "navigation was interrupted" — so we silence it to avoid noisy console errors.
    window.addEventListener('unhandledrejection', function (event) {
        if (event.reason instanceof DOMException && event.reason.name === 'AbortError') {
            event.preventDefault();
        }
    });

    // Dark mode: follow live system preference changes
    (function() {
        var mq = window.matchMedia('(prefers-color-scheme: dark)');
        function applySystemTheme() {
            var cookie = document.cookie.match('(?:^|; )theme=([^;]*)');
            var pref = cookie ? decodeURIComponent(cookie[1]) : 'system';
            // Only auto-follow system if user preference is 'system'
            if (pref !== 'dark' && pref !== 'light') {
                document.documentElement.classList.toggle('dark', mq.matches);
            }
        }
        mq.addEventListener('change', applySystemTheme);
    })();

    // Helper function to add/remove classes
    function toggleClasses(selector, addClasses = [], removeClasses = []) {
        const elements = document.querySelectorAll(selector);
        elements.forEach(el => {
            removeClasses.forEach(cls => el.classList.remove(cls));
            addClasses.forEach(cls => el.classList.add(cls));
        });
    }

    // Helper function to get element by selector
    function $(selector) {
        if (typeof selector === 'string') {
            return document.querySelector(selector);
        }
        return selector;
    }

    // Helper function to get all elements by selector
    function $$(selector) {
        return document.querySelectorAll(selector);
    }

    window.iniciarFunciones = function () {
        const status = window.status || 0;

        if (status === 3 && window.location.pathname !== "/desactivado") {
            Facturavia.link('/desactivado');
            return;
        }

        // Remove active classes from all menu items
        const menuActiveClasses = ['lg:hover:!bg-[#eee]', 'font-bold', 'lg:bg-[#0000000a]'];
        const menuActiveClassesAlt = ['lg:hover:!bg-[#0000000a]', 'font-bold', 'lg:bg-[#0000000a]'];

        $$('#mainmenu li a').forEach(el => {
            menuActiveClasses.forEach(cls => el.classList.remove(cls));
        });

        const pathname = window.location.pathname;
        const search = window.location.search;

        // Define menu highlighting logic
        const menuRules = [
            { condition: () => pathname === "/", selector: '#lhome', removeAsesorias: true },
            { condition: () => pathname.includes('/facturas-emitidas'), selector: '#lemitidas', removeAsesorias: true },
            { condition: () => pathname.includes('/documentos/scanner'), selector: '#llgastos', removeAsesorias: true },
            { condition: () => pathname.includes('/facturas-recibidas'), selector: '#lrecibidas', removeAsesorias: true },
            { condition: () => pathname.includes('/facturas') || search.includes('doc=factura'), selector: '#linvoice,#lemitidas', removeAsesorias: true },
            { condition: () => pathname.includes('/presupuestos') || search.includes('doc=presupuesto'), selector: '#lpresupuestos', removeAsesorias: true },
            { condition: () => pathname.includes('/gastos/reader') || search.includes('doc=gasto'), selector: '#llgastos', removeAsesorias: true },
            { condition: () => pathname.includes('/gastos') || search.includes('doc=gasto'), selector: '#lgastos', removeAsesorias: true },
            { condition: () => pathname.includes('/albaran') || search.includes('doc=albaran'), selector: '#lalbaran', removeAsesorias: true },
            { condition: () => pathname.includes('/contactos') || pathname.includes('/clientes'), selector: '#lcontact', removeAsesorias: true },
            { condition: () => pathname.includes('/productos'), selector: '#lproductos', removeAsesorias: true },
            { condition: () => pathname.includes('/quarter'), selector: '#lquarter', removeAsesorias: true },
            { condition: () => pathname.includes('/proformas'), selector: '#lproformas', removeAsesorias: true },
            { condition: () => pathname.includes('/taxs'), selector: '#lquarter', removeAsesorias: true },
            { condition: () => pathname.includes('/remesas'), selector: '#lremesas', removeAsesorias: true },
            { condition: () => pathname.includes('/referral-program'), selector: '#lreferral', removeAsesorias: true },
            { condition: () => pathname.includes('/trazabilidad'), selector: '#ltrazabilidad', removeAsesorias: true },
            { condition: () => pathname.includes('/documents-sent'), selector: '#ldocumentssent', removeAsesorias: true },
            { condition: () => pathname.includes('/documents-received'), selector: '#ldocumentsreceived', removeAsesorias: true },
            { condition: () => pathname.includes('/uploads'), selector: '#luploads', removeAsesorias: true },
            { condition: () => pathname.includes('/contabilidad/configuracion'), selector: '#lcontabilidadconfiguracion', removeAsesorias: true },
            { condition: () => pathname.includes('/contabilidad/periodos'), selector: '#lperiodos', removeAsesorias: true },
            { condition: () => pathname.includes('/gestion-contable'), selector: '#lgestioncontable', removeAsesorias: true },
            { condition: () => pathname.includes('/transacciones'), selector: '#ltransacciones', removeAsesorias: true },
            { condition: () => pathname.includes('/exportar') || pathname.includes('/settings/export'), selector: '#lexportar', removeAsesorias: true },
            { condition: () => pathname.includes('/asesoria-enviados'), selector: '#lasesoria-enviados', removeAsesorias: true },
            { condition: () => pathname.includes('/asesoria-recibidos'), selector: '#lasesoria-recibidos', removeAsesorias: true },
            { condition: () => pathname.includes('/asesoria-subir'), selector: '#lasesoria-subir', removeAsesorias: true },
            { condition: () => pathname.includes('/partners-referral-program'), selector: '#lclientes2', removeAsesorias: false, addAsesorias: true, removeSelector: '#lclientes' },
            { condition: () => pathname.includes('/partners'), selector: '#lclientes,#lpartners', removeAsesorias: false, addAsesorias: true, removeSelector: '#lclientes2' },
        ];

        for (const rule of menuRules) {
            if (rule.condition()) {
                rule.selector.split(',').forEach(sel => {
                    const el = $(sel);
                    if (el) {
                        menuActiveClassesAlt.forEach(cls => el.classList.add(cls));
                    }
                });

                const btnAsesorias = $('#btn-asesorias');
                if (btnAsesorias) {
                    if (rule.removeAsesorias) {
                        menuActiveClassesAlt.forEach(cls => btnAsesorias.classList.remove(cls));
                    } else if (rule.addAsesorias) {
                        menuActiveClassesAlt.forEach(cls => btnAsesorias.classList.add(cls));
                    }
                }

                if (rule.removeSelector) {
                    const removeEl = $(rule.removeSelector);
                    if (removeEl) {
                        menuActiveClassesAlt.forEach(cls => removeEl.classList.remove(cls));
                    }
                }
                break;
            }
        }

        if (pathname === "/logout") {
            window.location.href = '/';
        }

        Facturavia.closemenu();
    };

    function cargarScriptInicial() {
        let href = window.location.pathname;
        if (href.endsWith('/')) {
            href = href.slice(0, -1);
        }
        // Script URL generation - not currently used but kept for compatibility
        // const scriptUrl = '/static' + href + '.js';
    }

    function cargarScript(scriptUrl) {
        if (document.querySelector('script[src="' + scriptUrl + '"]')) {
            return;
        }
        const script = document.createElement('script');
        script.src = scriptUrl;
        script.async = false;
        script.dataset.dynamic = "true";
        document.body.appendChild(script);
        script.onload = function () {};
        script.onerror = function () {
            console.error('Error al cargar el script: ' + scriptUrl);
        };
    }

    window.cargarScript = cargarScript;
    window.cargarScriptInicial = cargarScriptInicial;

    function applyPjaxUpdates(root) {
        root.querySelectorAll('[data-pjax-update]').forEach(function (u) {
            const action = (u.dataset.pjaxUpdate || '').toString();
            const target = (u.dataset.target || '').toString();
            if (!action || !target) return;
            const t = document.querySelector(target);
            if (!t) return;

            const value = u.dataset.value ?? '';

            if (action === 'text') {
                if (t.tagName === 'TITLE') document.title = value;
                else t.textContent = value;
                return;
            }
            if (action === 'html') {
                t.innerHTML = value;
                return;
            }
            if (action === 'attr') {
                const attr = (u.dataset.attr || '').toString();
                if (!attr) return;
                t.setAttribute(attr, value);
                return;
            }
            if (action === 'toggleClass') {
                const cls = (u.dataset.class || '').toString();
                const enabled = String(u.dataset.enabled ?? '0') === '1';
                if (!cls) return;
                t.classList.toggle(cls, enabled);
                return;
            }
            if (action === 'value') {
                t.value = value;
                return;
            }
            if (action === 'append') {
                t.insertAdjacentHTML('beforeend', value);
                return;
            }
            if (action === 'replaceWith') {
                t.outerHTML = value;
                return;
            }
        });
    }

    // Delegated click handler for db_div and popover-link elements.
    // Uses event delegation so it works even after DOM replacement (e.g. search).
    let _clickDelegationInitialized = false;
    function setupClickHandlers() {
        if (_clickDelegationInitialized) return;
        _clickDelegationInitialized = true;

        document.addEventListener('click', function (event) {
            if (event.target.closest('.js-stop-propagation, .showMenuDoc')) return;

            const el = event.target.closest('.db_div, .popover-link');
            if (!el) return;

            if (el.classList.contains('popover-link')) {
                event.stopPropagation();
            }

            const url = el.dataset.url;
            if (!url) return;

            Facturavia.link(url);
        });

        // Middle-click: open in new tab
        document.addEventListener('auxclick', function (event) {
            if (event.button !== 1) return;
            if (event.target.closest('.js-stop-propagation, .showMenuDoc')) return;

            const el = event.target.closest('.db_div, .popover-link');
            if (!el) return;

            const url = el.dataset.url;
            if (!url) return;

            event.preventDefault();
            window.open(url, '_blank');
        });
    }

    // Add app-specific styles when running in React Native WebView
    function addAppStyles() {
        if (Facturavia.isApp()) {
            const style = document.createElement('style');
            style.innerHTML = `
                a, img, * {
                -webkit-user-drag: none !important;
                user-select: none !important;
                }
            `;
            document.head.appendChild(style);
        }
    }

    // Register Turbo event handlers IMMEDIATELY (not inside DOMContentLoaded).
    // These handlers must be ready early so they are available before
    // turbo:frame-load fires on SPA navigation.

    // Update CSRF meta tag from Turbo frame response headers.
    // The server sends X-CSRF-Token on every Turbo frame response to keep
    // the client-side token in sync (prevents stale/expired token errors).
    document.addEventListener('turbo:before-fetch-response', function (event) {
        const csrfToken = event.detail.fetchResponse.response.headers.get('X-CSRF-Token');
        if (csrfToken) {
            let meta = document.querySelector('meta[name="csrf-token"]');
            if (meta) {
                meta.content = csrfToken;
            } else {
                meta = document.createElement('meta');
                meta.name = 'csrf-token';
                meta.content = csrfToken;
                document.head.appendChild(meta);
            }
        }
    });

    // Before frame fetch - show loading state
    document.addEventListener('turbo:before-fetch-request', function (event) {
        // Only handle requests for the main frame
        if (event.target.id !== 'main') return;

        showProgressBar();

        const mainMenu = document.getElementById('mainmenu');
        const mobileMenuOpen = mainMenu && !mainMenu.classList.contains('ml-[-100%]');

        if (mobileMenuOpen) {
            Facturavia.closemenu();
            // Clear content immediately so the user sees a white screen while loading
            const main = document.getElementById('main');
            if (main) main.innerHTML = '';
        } else {
            loadingTimeout = setTimeout(function () {
                const main = document.getElementById('main');
                if (main) main.innerHTML = '';
                const loadingScreen = document.getElementById('loadingScreen');
                if (loadingScreen) loadingScreen.classList.remove('hidden');
            }, 200);
        }
    });

    // Frame render event (when new content is rendered in frame)
    // NOTE: Only handle visual cleanup here. All initialization (preload,
    // setupClickHandlers, iniciarFunciones) runs in turbo:frame-load to
    // avoid double-init since both events fire for the same navigation.
    document.addEventListener('turbo:frame-render', function (event) {
        // Only handle the main frame
        if (event.target.id !== 'main') return;

        hideProgressBar();

        const main = document.getElementById('main');
        if (main) {
            applyPjaxUpdates(main);
        }

        if (Facturavia.isApp()) {
            document.querySelectorAll('.mx-auto.sticky').forEach(el => {
                el.style.top = '0';
            });
            document.body.classList.add('no-select');
            addAppStyles();
        }

        clearTimeout(loadingTimeout);
        const loadingScreen = document.getElementById('loadingScreen');
        if (loadingScreen) loadingScreen.classList.add('hidden');
    });

    // Frame load event (frame fully loaded)
    document.addEventListener('turbo:frame-load', function (event) {
        if (event.target.id !== 'main') return;

        clearTimeout(loadingTimeout);
        const loadingScreen = document.getElementById('loadingScreen');
        if (loadingScreen) loadingScreen.classList.add('hidden');

        // Update title after frame is fully loaded (and history advanced)
        const main = document.getElementById('main');
        if (main) {
            applyPjaxUpdates(main);
        }

        window.iniciarFunciones();
        Facturavia.preload();
        setupClickHandlers();
    });

    // Prevent Turbo from promoting a frame response to a full-page visit
    // when the response doesn't contain the expected <turbo-frame>.
    // Without this, Turbo replaces the entire <body>, removing the header
    // and sidebar menu.  Instead we do a hard browser navigation so the
    // server renders the full shell (header + menu + frame).
    document.addEventListener('turbo:frame-missing', function (event) {
        event.preventDefault();
        var url = (event.detail && event.detail.response)
            ? event.detail.response.url
            : window.location.href;
        window.location.href = url || window.location.href;
    });

    // Also handle initial page load and Turbo.visit() navigation
    document.addEventListener('turbo:load', function (event) {
        clearTimeout(loadingTimeout);
        const loadingScreen = document.getElementById('loadingScreen');
        if (loadingScreen) loadingScreen.classList.add('hidden');

        window.iniciarFunciones();
        Facturavia.preload();
        setupClickHandlers();
    });

    // DOM-dependent initialization
    document.addEventListener('DOMContentLoaded', function () {
        cargarScriptInicial();

        addAppStyles();
    });

    // Export Turbo for use in other modules
    window.Turbo = Turbo;
}
